import { matchPath } from 'react-router';

export const pathsIsTheSame = (
  path: string,
  paramsPath: string
): boolean | undefined => {
  let result = matchPath(path, {
    path: paramsPath,
    exact: true,
    strict: false,
  })?.isExact;
  return result;
};
